export default "__VITE_ASSET__BIoD_GiD__"